import { ROUTES } from "@unreserved/constants/routes";

const AddressIcon = "/icons/landing-page/address-icon.svg";
const EmailIcon = "/icons/landing-page/email-icon.svg";
const PhoneIcon = "/icons/landing-page/phone-icon.svg";

export const contactInfo = [
  {
    icon: PhoneIcon,
    label: "Contact",
    value: "310-437-2766",
    alt: "Phone",
    href: "tel:3104372766",
  },
  {
    icon: EmailIcon,
    label: "Email",
    value: "info@example.com",
    alt: "Email",
    href: "mailto:info@example.com",
  },
  {
    icon: AddressIcon,
    label: "Address",
    value: "123 Main St, Anytown, Australia",
    alt: "Address",
    href: undefined,
  },
] as const;

export const navigationLinks = [
  { href: "/about", label: "About us" },
  { href: ROUTES.UNAUTHENTICATED.CONTACT_US, label: "Contact" },
  { href: ROUTES.UNAUTHENTICATED.PRIVACY_POLICY, label: "Privacy policy" },
  { href: "/sitemap.xml", label: "Sitemap" },
  { href: ROUTES.UNAUTHENTICATED.TERMS_AND_CONDITIONS, label: "Terms of Use" },
] as const;

export const footerData = {
  description:
    "We ara a lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat...",
  fullDescription:
    "We ara a lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.",
  copyright: "© 2000-2021, All Rights Reserved",
} as const;
